import React from 'react';
import * as misConstantes from '../../js/constantes';
//import './css/estilos.css';
//import './css/main.css';
//import './css/style.css';
//import './css/app.css';
//import './css/bootstrap/bootstrap.css';
//import './css/menu.css';
import logodnp from '../../img/cce-color.png';
import logoFooter from '../../img/LogoGovCo.png';
//
import youTubeFooter from '../../img/youtubeFooter.png';
import twitterFooter from '../../img/twitterFooter.png';
import facebookFooter from '../../img/facebookFooter.png';
import linkedinFooter from '../../img/linkedinFooter.png';
import RSSFooter from '../../img/RSSFooter.png';


import VersionApp from "../template/VersionApp";
//import Menu from './pages/template/Menu.js' ;

//function TemplateInicio(  ) {

	
class ErrorAutenticacion extends React.Component {
	
	
	constructor(props) {
    	super(props);
		this.state = {}
  	}
	
	

	render(){
		 return (
		<div>
		    <div class="content" style={{display: 'fixed', width: '100%', top: '0px'}} id = 'cabezoteAzulLogosBlanco'>
				<div class="fondo-azul-sin-texto"></div>
				<div class="fondo-azul" style = {{marginBottom: '20px'}}>
					<div class="container" >
						<nav class="navbar navbar-expand-lg navbar-light" style = {{paddingLeft: "0px"}}>
							<div class="logoGov">
								<a href="https://www.gov.co/" target="_blank"><img alt="Logo colombia compra"  style={{ maxWidth: '150px' }} class="img-fluid logovco" src="https://1a1.click/img/Logo%20govco.png" /></a>
							</div>
							<ul class="navbar-nav ml-auto">
								<li class="nav-item active" style={{paddingTop: '2px'}}>
								</li>
							</ul>
						</nav>	
						
					</div>
						<div class="container">
							<div class="fila">
								<div class="col-6 col-md-3 mr-auto" style={{paddingLeft: '10px !important' }}>
								</div>
								<div class="col-6 col-md-3 ml-auto" style={{paddingLeft: '10px !important' }}>
									<a href="https://www.colombiacompra.gov.co/"><img id="logodnp" src={ logodnp } /></a>
								</div>
							</div>
						</div>
				</div>
			</div>
			
			
			
			
			{/*	https://oportunidades.colombiacompra.gov.co/app/ServletTextosSinAutenticar  https://dynaco.co/simulador/test  http://localhost:8080/Simulador/ */}
			
			<div class="container" style={{minHeight: '550px', paddingTop: "120px"}}>
			
			
			
			
			
			
			
				<div class="fila">
					<div class="col-lg-3 col-md-3 col-sm-12 mr-auto" style={{paddingLeft: "10px !important" }} >
						
						
					</div>
				
					<div class="col-lg-6 col-md-6 col-sm-12 mr-auto" style={{paddingLeft: "10px !important"}} >
						<div style={{width: "100%", backgroundColor:  "#42b6e7", padding: "10px", color: "white", textAlign: "center" }}>
							Autenticaci&oacute;n
						</div>
						<div style={{width: "100%", backgroundColor:  "#466ea6", padding: "10px", color: "white", textAlign: "center" }}>
							Error en la autenticación
						</div>
						<div>
							El código que nos estás enviando es inválido
						</div>
						
						
					</div>
					
					<div class="col-lg-3 col-md-3 col-sm-12 mr-auto" style={{paddingLeft: "10px !important" }} >
						
						
					</div>
					
					
					
				</div>

			
			
			
			
			
			
			
			
			</div>
			<div style={{backgroundColor: "#0164c1"}}>
				<div class="container foot pt-4">
					<div class="fila">
						<div class="col-12 col-md-2 bd">
							<img class="img-fluid" src={logoFooter}/>
						</div>
						
						
						
						
						<div class="col-12 col-md-6 py-4 bd">
							<h5 class="blanco ">Colombia Compra Eficiente</h5>
							
							
							<p class="blanco small">
								Carrera 7 No 26 - 20 Piso 23 / Dirección General / Edificio
								Seguros Tequendama (Bogotá D.C)<br/>
								Código Postal: 110311<br/>
								Horario de atención: de 8:30 a.m a 430 p.m / Lunes a Viernes
							</p>
							
							
							
							<p>
								<a class="blanco" href="/sitemap">Mapa del sitio</a>
							</p>
							<div class="fila">
								<div class="col-md-1 col-2">
									<a href="https://www.facebook.com/ColombiaCompraEficiente/" target="_blank"><img alt="facebook" src={facebookFooter}/></a>
								</div>
								<div class="col-md-1 col-2">
									<a href="https://twitter.com/colombiacompra" target="_blank"><img alt="twitter" src={twitterFooter}/></a>
								</div>
								<div class="col-md-1 col-2">
									<a href="https://www.linkedin.com/company/colombia-compra-eficiente/" target="_blank"><img alt="linkedin" src={linkedinFooter}/></a>
								</div>
								<div class="col-md-1 col-2">
									<a href="https://www.youtube.com/channel/UC2pHOdAhZovC5vE7IsuiGbg" target="_blank"><img alt="youtube" src={youTubeFooter}/></a>
								</div>
								<div class="col-md-1 col-2">
									<a href="/node/22/" target="_blank"><img alt="rss" src={RSSFooter}/></a>
								</div>
							</div>
						</div>
						<div class="col-12 col-md-4 py-4">
							<h6 class="blanco">Contacto de notificaciones judiciales</h6>
							<p class="blanco small" style={{color: "white"}}>
								<a target="_blank" class="blanco" href="mailto:notificacionesjudiciales@colombiacompra.gov.co">notificacionesjudiciales@colombiacompra.gov.co</a><br/>
								Nit. 900514913-2<br/> Linea nacional gratuita: 018000520808<br/>
								PBX: (+57) (1) 7956600<br/> Línea en Bogotá: (+57) (1) 7456788
							</p>
						</div>
					</div>
					<div class="col-12">
						<hr/>
						<div class="d-flex flex-wrap justify-content-between">
							<p class="text-left blanco">&copy; {new Date().getFullYear()}. Colombia Compra Eficiente Todos los derechos reservados</p>
							<VersionApp />
						</div>
					</div>
				</div>
			</div>
		
		</div>
		
	  )
	}
	
	
}

export default ErrorAutenticacion;